import { createStyles } from '@material-ui/styles';
import palette from 'theme/palette';

export default () =>
  createStyles({
    containerTitle: {
      alignItems: 'center',
      marginLeft: 8,
      '& .MuiOutlinedInput-root': {
        height: 45,
        width: 400,
      },

      '& .MuiGrid-container': {
        alignItems: 'center',
      },
    },
    personIcon: {
      color: palette.darkGray,
      width: 40,
      height: 40,
    },
    cardTitles: {
      paddingRight: 7,
      fontWeight: 600,
      fontSize: 14,
      fontFamily: 'Roboto',
      display: 'flex',
      alignItems: 'center',
    },
    cardName: {
      paddingLeft: 7,
      fontWeight: 500,
      fontFamily: 'Roboto',
      fontSize: 18,
    },
    cardInfos: { paddingTop: 10, paddingLeft: 10 },
    alignLines: { alignItems: 'center !important', justifyContent: 'center' },
    cardContent: { alignItems: 'baseline !important' },
    responsiveGrid: {
      display: 'flex',
      alignItems: 'baseline',
    },
    cardValues: {
      whiteSpace: 'nowrap',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      fontSize: 14,
    },
    card: {
      boxShadow: '0 2px 4px 0 rgb(0 0 0 / 40%)',
      borderRadius: 8,
      margin: 10,
      padding: 10,
    },
    sessionsTable: {
      margin: 10,
    },
    buttonContainer: {
      color: palette.red,
      padding: 0,

      '&:hover': {
        opacity: 0.8,
      },
      '&:disabled': {
        color: palette.gray,
        opacity: 0.5,
      },
      '& .MuiIconButton-root': { padding: 0 },
    },
    icon: {
      height: 15,
      width: 15,
      padding: 0,
      '& .MuiIconButton-root': { padding: 0 },
    },
    checkboxCell: {
      padding: '0 0 0 15px !important',

      '& .MuiCheckbox-root': {
        padding: 0,
      },

      '& span > span > svg': { width: 15, height: 15 },
    },
  });
